import { Box } from '@mui/material';
import './HaleLoginLeftPanel.css';

const HaleLoginLeftPanel = () => (
  <Box className="hale-login-left">
    <Box className="hale-login-left__glow hale-login-left__glow--gold" />
    <Box className="hale-login-left__glow hale-login-left__glow--blue" />

    <Box className="hale-login-left__graphic">
      <Box className="hale-login-left__rings">
        <Box className="hale-login-left__ring" />
        <Box className="hale-login-left__ring-line hale-login-left__ring-line--vertical" />
        <Box className="hale-login-left__ring-line hale-login-left__ring-line--horizontal" />
      </Box>

      <Box className="hale-login-left__squares">
        <Box className="hale-login-left__square hale-login-left__square--a" />
        <Box className="hale-login-left__square hale-login-left__square--b" />
      </Box>

      <Box className="hale-login-left__center">
        <Box className="hale-login-left__center-inner" />
      </Box>
    </Box>
  </Box>
);

export default HaleLoginLeftPanel;
